import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useDemographics } from "~/sdks/LocalDemographics/context";

import type { Variable } from "@local-logic/client";

import { DemographicsTextCard } from "~/components/DemographicsTextCard";

import * as styles from "../../styles";

export const EmploymentStatus = () => {
  const { t } = useTranslation("localDemographics");
  const {
    demographicsState: { employment_status: employmentStatus },
  } = useDemographics();

  const datasets = useMemo(
    () =>
      employmentStatus?.variables.map((variable: Variable) => ({
        label: variable.label,
        data: Number((variable.value * 100).toFixed(1)),
      })) || [],
    [employmentStatus?.variables]
  );

  const chartOptions = useMemo(
    () => ({
      options: {
        title: t("data.income.graphs.employment.title"),
        values: datasets.map((item) => ({
          variable: item.label.replace(" ", "_"),
          label: item.label,
          value: `${item.data}%`,
        })),
      },
    }),
    [datasets]
  );

  if (!employmentStatus) {
    return null;
  }

  return (
    <div className={styles.cardContainer}>
      <DemographicsTextCard {...chartOptions} />
    </div>
  );
};
